module.exports = __webpack_public_path__ + "static/media/icon_clock.e2a05522.svg";